import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4f276d66"
import script from "./_loader.js?vue&type=script&lang=js&external"
export * from "./_loader.js?vue&type=script&lang=js&external"
import style0 from "./_loader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports